<template>
  <div>
    <MassAgentUpdateDialog 
      v-if="$store.state.massUpdateDialog"
      :userId="localId"
      :managerName="localName"
      :managerLevel="'local'"
    />

    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->

      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({
                      name: 'AdministratorUsersLocalManagersCreate',
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon small left>mdi-plus</v-icon>
                {{ $t("newLocalManager") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          class="elevation-1 mb-3"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
          </template>

          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  '/administrator/locals/getLocal'
                )
              "
            >
              <v-icon color="green" small>mdi-account-multiple</v-icon>
              {{ item.name_local }}
            </a>
            <v-chip
              v-if="item.comissao_online"
              color="primary"
              small
              class="ml-1"
            >
              {{ $t("affiliate") }}
            </v-chip>
          </template>

          <template v-slot:item.status="{ item }">
            <v-icon :color="colorStatus(item.status)" size="16">
              mdi-circle
            </v-icon>
          </template>

          <template v-slot:item.data_cadastro="{ item }">
            <span class="caption">{{ item.data_cadastro }}</span>
          </template>

          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      $profile.showProfileDrawer(
                        item.id,
                        '/administrator/locals/getLocal'
                      )
                    "
                  >
                    <v-icon>mdi-account-multiple</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("profile") }} </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name: 'AdministratorUsersLocalManagersEdit',
                          params: { id: item.id },
                        }),
                        showDialog(),
                      ]
                    "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("edit") }} </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="openMassUpdateDialog(item)"
                  >
                    <v-icon>mdi-account-convert</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("massAgentsUpdateTitle") }} </span>
              </v-tooltip>
              <MenuDropdownStatusUser
                :id_user="item.id"
                :status_user="item.status"
              />
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <router-view></router-view>
  </div>
</template>
<script>
import MenuDropdownStatusUser from "@/components/administrator/menu/dropdownStatusUser.vue";
import HeaderPrint from "@/components/common/header-print";
import MassAgentUpdateDialog from "@/components/common/dialog/dialogMassAgentUpdate.vue";

export default {
  components: { MenuDropdownStatusUser, HeaderPrint, MassAgentUpdateDialog },
  name: "administrator-users-local-managers-list",
  data: () => ({
    data: [],
    search: "",
    localId: 0,
    localName: ""
  }),
  computed: {
    headers() {
      return [
        { text: "Id", value: "id" },
        { text: this.$t("status"), value: "status" },
        { text: this.$t("name"), value: "name_local" },
        { text: this.$t("login"), value: "login_local" },
        { text: this.$t("createdIn"), value: "data_cadastro" },
        {
          text: this.$t("actions"),
          value: "action",
          align: "center d-print-none",
        },
      ];
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    // 2. Setup Filters
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    // 3. Setup Filters
    saveFilters(val) {
      val && this.getDataTable();
    },
    refresh(val) {
      val && this.getDataTable();
      this.$store.commit("setRefresh", false);
    },
  },
  methods: {
    openMassUpdateDialog(item) {
      this.localId = item.id;
      this.localName = item.name_local;
      this.$store.commit("massUpdateDialog", true);
    },
    resetPage() {
      this.search = "";
    },

    async getDataTable() {
      const body = { status: this.status, id_regional: this.id_regional };
      const response = await this.$request.post(
        "administrator/locals/list",
        body
      );

      this.data = response.dados;
      this.data = this.data.map((item) => {
        item.data_cadastro = new Date(
          item.data_cadastro.replace(" ", "T")
        ).toLocaleString();
        return item;
      });
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
    // handle color status
    colorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },
  },
};
</script>
